import React from 'react';
import styled from 'styled-components';
import TrueImpactCapsule from 'shared/design-system/components/TrueImpactCapsule';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';

export const budgetTableGridStyles = `
  display: grid;
  gap: ${SPACERS.small};
  align-items: center;
  grid-template-columns: 2fr 2fr 1fr;
  padding: ${SPACERS.small} ${SPACERS.extraLarge};
`;

const StyledDiv = styled.div`
  ${budgetTableGridStyles}
  background-color: ${COLORS.grayLight};
`;

const style: React.CSSProperties = { justifySelf: 'center' };
const ReportBudgetHeader: React.FC = () => {
  return (
    <StyledDiv>
      <div>
        <TrueImpactCapsule
          variant="body-small-bold"
          backgroundColor="grayLightest"
        >
          EXPENSE/DONATION TYPE
        </TrueImpactCapsule>
      </div>
      <div style={style}>
        <TrueImpactCapsule
          variant="body-small-bold"
          backgroundColor="grayLightest"
        >
          AMOUNT BUDGETED
        </TrueImpactCapsule>
      </div>
      <div>
        <TrueImpactCapsule
          variant="body-small-bold"
          backgroundColor="grayLightest"
        >
          VARIANCE
        </TrueImpactCapsule>
      </div>
    </StyledDiv>
  );
};

export default ReportBudgetHeader;
